import { Link as RouterLink } from "react-router-dom";

import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  AccessTime,
  CalendarMonthOutlined,
  LocationOnOutlined,
} from "@mui/icons-material";

import { EventCardInterface } from "../../interfaces";
import { useTheme } from "@emotion/react";

export const EventCard = ({
  name,
  startDate,
  address,
  banner,
  id,
  category,
}: EventCardInterface) => {



  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md")); // Detecta si la pantalla es de escritorio o móvil

  let calendarDate = new Date(startDate).toLocaleDateString("es-CR", {
    weekday: isDesktop ? "long" : "long", // Larga para escritorio, corta para móvil
    month:isDesktop ? "long" : "short", // Larga para escritorio, corta para móvil
    day: "numeric",
  });

  let timeDate = new Date(startDate).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <Box display={"flex"} height="100%">
      <Card
        sx={{
          borderRadius: "15px 15px 15px 15px",
          overflow: "visible",
        }}
        elevation={9}
      >
        <CardContent sx={{ padding: { xs: "7px", sm: "0px" }, flexGrow: 1 }}>
          <Grid container>
            <Grid
              item
              xs={12}
              component={RouterLink}
              to={`/event/${id}`}
              sx={{
                mb: 3,
                flexGrow: 1,
                position: "relative",
                "&:hover": {
                  ".image-overlay": {
                    opacity: 1,
                    filter: "brightness(50%)",
                  },
                  ".hover-text": {
                    display: "flex",
                  },
                },
              }}
            >
              <CardMedia
                component="img"
                alt="banner image"
                image={banner}
                sx={{
                  borderRadius: "5px",
                  height: { xs: 200, sm: 400 },
                  width: "100%",
                  transition: "0.5s ease",
                  position: "relative",
                }}
                className="image-overlay"
              />
              <Typography
                variant="h6"
                component="div"
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#e9edef",
                  display: "none",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  zIndex: 1,
                  transition: "display 0.5s ease-in-out",
                }}
                className="hover-text"
              >
                Ver evento
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              mb={1}
              ml={{ xs: 0, sm: 2 }}
              sx={{
                zIndex: 2,
                overflow: "hidden",

                alignItems: "center",
                justifyContent: "flex-start",
                display: "flex",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  padding: { xs: "2px 15px", sm: "6px 12px" },
                  alignItems: "center",
                  borderRadius: "15px",
                  background: "#CE3197",
                }}
              >
                <Typography
                  sx={{
                    color: "#FAFAFA",
                    fontFeatureSettings: "'liga' off, 'clig' off",

                    fontSize: { xs: "0.6rem", sm: "13px" },
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "18px",
                    letterSpacing: "0.16px",
                  }}
                >
                  {category}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sx={{ zIndex: 2, overflow: "hidden", }} ml={{ xs: 0, sm: 2 }}>
              <Tooltip title={name} placement="top" arrow>
                <Typography
                  gutterBottom
                  variant="h6"
                  color={"text.primary"}
                  fontWeight={"bold"}
                  component="div"
                  sx={{
                    fontSize: { xs: "0.8rem", sm: "24px" },
                  }}
                >
                  {name}
                </Typography>
              </Tooltip>
            </Grid>
            <Grid
              item
              display={"flex"}
              alignItems="center"
              xs={12}
              sm={12}
              ml={{ xs: 0, sm: 2 }}
              sx={{}}
            >
              <CalendarMonthOutlined
                sx={{
                  fontSize: { xs: "0.7rem", sm: "14px" },
                }}
              />
              <Typography
                variant="body2"
                color="text.white"
                sx={{
                  ml: 0.5,
                  fontSize: { xs: "0.7rem", sm: "14px" },
                }}
              >
                {calendarDate}
              </Typography>
            </Grid>

            <Grid
              item
              display={"flex"}
              alignItems="center"
              xs={12}
              sm={12}
              justifyContent={"flex-start"}
              ml={{ xs: 0, sm: 2 }}
              sx={{
                mt: 1,
              }}
            >
              <AccessTime
                sx={{
                  fontSize: { xs: "0.7rem", sm: "14px" },
                }}
              />
              <Typography
                variant="body2"
                color="text.white"
                sx={{
                  ml: 0.5,
                  marginTop: 0.2,
                  fontSize: { xs: "0.7rem", sm: "14px" },
                }}
              >
                {timeDate}
              </Typography>
            </Grid>

            <Grid
              item
              display={"flex"}
              alignItems="flex-start"
              ml={{ xs: 0, sm: 2 }}
              sx={{ mt: 1, width: "100%" }}
            >
              <LocationOnOutlined
                color="action"
                sx={{
                  fontSize: { xs: "0.8rem", sm: "14px" },
                }}
              />
              <Tooltip title={address} placement="top" arrow>
                <Typography
                  variant="body2"
                  color="text.white"
                  sx={{
                    ml: 0.5,
                    fontSize: { xs: "0.7rem", sm: "14px" },
                    textOverflow: "ellipsis",

                    overflow: "hidden",
                  }}
                >
                  {address}
                </Typography>
              </Tooltip>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};
